import { render, staticRenderFns } from "./FCart.vue?vue&type=template&id=5ec2f657&scoped=true"
import script from "./FCart.vue?vue&type=script&lang=js"
export * from "./FCart.vue?vue&type=script&lang=js"
import style0 from "./FCart.vue?vue&type=style&index=0&id=5ec2f657&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2f657",
  null
  
)

export default component.exports